"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDynamicColumnFormConfig = void 0;
const addDynamicColumnFormConfig = (entities, columnHandlers) => {
    return {
        type: 'form',
        children: [
            {
                type: 'form.select',
                key: 'entity',
                label: 'Entity',
                values: entities.map((e) => ({ value: e, label: e })),
                validate: {
                    required: true,
                },
            },
            {
                type: 'form.text',
                key: 'name',
                label: 'Name',
                validate: {
                    required: true,
                    regex: '[a-z][a-zA-Z0-9_]*',
                    custom: (value) => {
                        if (value && value.length <= 50) {
                            return undefined;
                        }
                        return 'Invalid Entry. Maximum number of characters is 50.';
                    },
                },
            },
            {
                type: 'form.text',
                key: 'dataPath',
                label: 'Data Path',
                validate: {
                    required: true,
                },
            },
            {
                type: 'form.text',
                key: 'metadata.label',
                label: 'Label',
                validate: {
                    required: true,
                },
            },
            {
                type: 'form.select',
                key: 'metadata.columnHandlerName',
                label: 'Handler',
                values: columnHandlers?.map((ch) => ({ value: ch.name, label: ch.label })),
            },
            {
                type: 'form.checkbox',
                key: 'multipleValues',
                label: 'Multiple Values',
                style: {
                    type: 'checkbox',
                },
                defaultValue: false,
                clearDataOnHide: true,
                hidden: {
                    custom: (handler) => {
                        const data = handler.up().down('metadata.columnHandlerName')?.getData();
                        const columnHandler = columnHandlers.filter((handler) => handler.name == data);
                        if (columnHandler.length) {
                            return !columnHandler[0]?.arrayColumnType;
                        }
                        return false;
                    },
                },
            },
            {
                type: 'form.checkbox',
                key: 'metadata.showInTable',
                label: 'Show In Table',
                style: {
                    type: 'checkbox',
                },
                defaultValue: false,
            },
            {
                type: 'form.checkbox',
                key: 'metadata.showInFilters',
                label: 'Show In Filter',
                style: {
                    type: 'checkbox',
                },
                defaultValue: false,
            },
        ],
    };
};
exports.addDynamicColumnFormConfig = addDynamicColumnFormConfig;
